module.exports = __webpack_public_path__ + "static/media/pic1.1ba446d2.png";